module.exports = __webpack_public_path__ + "img/package_5.59498cec.png";